export default {
  index: 'mailing-inbox',
};
